import cls from "./AboutPage.module.scss";
import {classNames} from "shared/lib/classNames/classNames";
import Title, {TitleTheme} from "shared/ui/Title/Title";
import Paragraph from "shared/ui/Paragraph/Paragraph";
import dino from '../../../shared/assets/dino.png'


export const AboutPage = () => {
    return (
        <div id={"aboutPage"} className={cls.aboutPage}>
            <section className={classNames("page-section", {}, [cls.aboutPage__about])}>
                <div className={classNames("container container__main")}>
                    <div className={cls.about}>
                        <div className={cls.about__title}>About Us</div>
                        <Paragraph>
                            About SBS CONSULTING STRATEGIES LTD
                        </Paragraph>
                        <Paragraph>
                            SBS CONSULTING STRATEGIES LTD is a dynamic company dedicated to creating high-quality apps and digital experiences for a diverse audience. Our latest project, Bloxsy: Steal Games, is crafted to bring creativity, excitement, and endless customization to fans of block-style games around the world.                        </Paragraph>
                        <Paragraph>
                            At SBS CONSULTING STRATEGIES LTD, we are passionate about building intuitive, user-friendly applications that enhance your gameplay. Our mission is to develop innovative and engaging tools that unlock new possibilities—whether you're a casual gamer or a dedicated enthusiast.                        </Paragraph>
                        <Paragraph>
                            Our talented team of developers, designers, and support professionals work diligently to ensure that our apps are simple to use, frequently updated, and continually refined to meet your needs. We place a strong emphasis on user feedback and aim to create experiences that go beyond expectations.                        </Paragraph>
                        <Paragraph>
                            We are equally committed to your safety and privacy, building a secure environment where you can confidently enjoy our services. Whether you're seeking unique skins, thrilling mods, or powerful tools, SBS CONSULTING STRATEGIES LTD is here to offer the very best in gaming enhancements.
                        </Paragraph>

                        <Paragraph>
                            If you have any questions or suggestions, we encourage you to reach out to us at any time. We’re always eager to hear from our users and to evolve our platform based on your insights.
                        </Paragraph>

                        <Paragraph>
                            Thank you for choosing SBS CONSULTING STRATEGIES LTD as your gaming companion!
                        </Paragraph>
                    </div>
                </div>
            </section>
            <img src={dino} className={cls.dino__image} alt="Dinosaur"/>
        </div>
    )
}
